import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CheckCircleIcon } from 'lucide-react';
export function WhatYouGet() {
  const items = [{
    title: 'La Guía Técnica "Clean Slate"',
    desc: '50 páginas de estrategia pura sobre cómo auditar tu propio reporte.'
  }, {
    title: 'Plantilla Round 1',
    desc: 'La carta de disputa masiva para limpiar errores de identidad y cuentas viejas.'
  }, {
    title: 'El Borrador HIPAA',
    desc: 'El método legal para eliminar deudas de hospitales y clínicas.'
  }, {
    title: 'Script de Negociación "Pay-for-Delete"',
    desc: 'Cómo pagar centavos por dólar y asegurar que borren la mancha de tu crédito.'
  }, {
    title: 'Checklist de Mantenimiento 700+',
    desc: 'Qué hacer para que tu puntaje nunca vuelva a caer tras la limpieza.'
  }];
  return <section className="py-24 bg-cream text-text-dark" data-id="element-160">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-161">
        <FadeIn data-id="element-162">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-navy mb-16" data-id="element-163">
            ¿Qué incluye tu <span className="text-gold" data-id="element-164">Clean Slate</span>?
          </h2>
        </FadeIn>

        <div className="space-y-6" data-id="element-165">
          {items.map((item, index) => <FadeIn key={index} delay={0.1 * index} direction="left" data-id="element-166">
              <div className="bg-white p-6 rounded-xl shadow-sm border border-cream-dark flex items-start gap-6 hover:shadow-md transition-shadow" data-id="element-167">
                <div className="flex-shrink-0 mt-1" data-id="element-168">
                  <CheckCircleIcon className="w-8 h-8 text-gold" data-id="element-169" />
                </div>
                <div data-id="element-170">
                  <h3 className="text-xl font-bold text-navy mb-2 font-serif" data-id="element-171">
                    {item.title}
                  </h3>
                  <p className="text-text-muted font-sans leading-relaxed" data-id="element-172">
                    {item.desc}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}